import { useEffect } from 'react'
import maplibregl from 'maplibre-gl'

// Native MapLibre controls: NavigationControl (zoom +/-, compass = reset
// orientation / reset north) and FullscreenControl (Fullscreen API). Added once
// the map exists; removed on unmount. Isolated here per the "MapLibre
// interactions behind specialized hooks" rule.
//
// The fullscreen button is only added when the browser will actually honour it.
// Inside an iframe the Fullscreen API is refused unless the frame carries
// `allow="fullscreen"`, so the dashboard's overview minimap showed a button
// that did nothing when clicked — a control that visibly fails is worse than an
// absent one. `document.fullscreenEnabled` is exactly that question, and
// answering it here fixes every embedding rather than only ours.
export function useNativeControls(map, { allowFullscreen = true } = {}) {
  useEffect(() => {
    if (!map.current) return
    const nav = new maplibregl.NavigationControl({
      showZoom: true,
      showCompass: true,     // click resets bearing to north / pitch to 0
      visualizePitch: true,
    })
    map.current.addControl(nav, 'top-right')

    const usable = allowFullscreen && typeof document !== 'undefined'
      && document.fullscreenEnabled !== false
    const fullscreen = usable ? new maplibregl.FullscreenControl() : null
    if (fullscreen) map.current.addControl(fullscreen, 'top-right')

    return () => {
      try { map.current?.removeControl(nav) } catch { /* map already gone */ }
      if (fullscreen) {
        try { map.current?.removeControl(fullscreen) } catch { /* map already gone */ }
      }
    }
  }, [map, allowFullscreen])
}
